import React, { useEffect, useState } from "react";

import '../styles/basePage.css';

const CustomerTransactionTab = ({
    selectedCustomer,
    setSelectedCustomer,
    fetchTransactionDetails,
    fetchCustomerData,
    currentPage,
    prevPage,
    nextPage,
    renderPageNumbers,
    totalPages,
    messageFlowType,
    senderName
}) => {
    const [dataLoaded, setDataLoaded] = useState(false);
    const [allData, setAllData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchType, setSearchType] = useState('customerName');
    const [referenceIdentifiers, setReferenceIdentifiers] = useState({}); // Track reference identifiers for each row

    useEffect(() => {
        if (fetchCustomerData && fetchCustomerData.CustomerEDITrnsactionDatails) {
            setDataLoaded(true);
            setAllData(fetchCustomerData.CustomerEDITrnsactionDatails);
            setFilteredData(fetchCustomerData.CustomerEDITrnsactionDatails);

        }
    }, [fetchCustomerData]);

    useEffect(() => {
        console.log("Reference Identifiers State:", referenceIdentifiers);
    }, [referenceIdentifiers]);

    useEffect(() => {
        console.log("Selected Customer State:", selectedCustomer);
    }, [selectedCustomer]);


    useEffect(() => {
        applyFilters();
    }, [searchQuery, searchType]);

    const applyFilters = () => {
        if (allData) {
            const filtered = allData.filter((item) => {
                if (searchType === 'customerName') {
                    return item?.CUSTOMER?.toLowerCase().includes(searchQuery.toLowerCase());
                } else if (searchType === 'transactionType') {
                    return item?.EDITransactionType?.toLowerCase().includes(searchQuery.toLowerCase());
                }
                return true;
            });
            setFilteredData(filtered);
        }
    };

    useEffect(() => { applyFilters(); }, [applyFilters])

    const handleCustomerSelection = (customerName, transactionType) => {
        const refId = referenceIdentifiers[`${customerName}-${transactionType}`] || "";
        setSelectedCustomer({
            customerName,
            transactionType,
            customerReferenceIdentifier: refId
        });
        console.log("customerReferenceIdentifier: ", refId)
    };

    const handleReferenceChange = (e) => {
        const { value, dataset: { transactionType, customerName } } = e.target;
        setReferenceIdentifiers(prev => {
            const newState = {
                ...prev,
                [`${customerName}-${transactionType}`]: value  // Update the state with the new reference identifier
            };
            setSelectedCustomer({
                customerName,
                transactionType,
                customerReferenceIdentifier: newState[`${customerName}-${transactionType}`]
            });
            return newState;
        });
    };

    const handleViewStatusClick = () => {
        const { customerName, transactionType } = selectedCustomer || {};
        const refId = referenceIdentifiers[`${customerName}-${transactionType}`] || "";
        console.log("referenceIdentifiers:", refId);

        if (!refId.trim()) {
            alert("Enter Reference-Identifier");
            return;
        }
        if (messageFlowType === "Outbound") {
            fetchTransactionDetails(selectedCustomer, senderName);
        } else {
            fetchTransactionDetails(selectedCustomer);
        }
    };

    const isViewStatusEnabled = (item) => {
        // Only enable if Reference-Identifier is not empty for the current row
        const refId = referenceIdentifiers[`${item?.CUSTOMER}-${item?.EDITransactionType}`];
        return refId && refId.trim() !== "";
    };

    if (!dataLoaded) {
        return <div>Loading...</div>;
    }

    return (
        <div>
            {/* Search and Filter */}
            <div className="search-container">
                <select
                    value={searchType}
                    onChange={(e) => setSearchType(e.target.value)}
                    className="search-dropdown"
                >
                    <option value="customerName">Customer Name</option>
                    <option value="transactionType">Transaction Type</option>
                </select>
                <input
                    type="text"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder={`Filter by ${searchType === 'customerName' ? 'Customer Name' : 'Transaction Type'}`}
                    className="search-input"
                />
                {/* <button onClick={applyFilters} className="filter-button">Search/Filter Transactions</button> */}
            </div>

            {filteredData?.length === 0 ? (
                <div>No transactions available</div>
            ) : (
                <div className="content_main">
                    <div className="customers_table">
                        <div className="table-header">
                            <div className="table-row">
                                <div className="table-cell">Customer Name</div>
                                <div className="table-cell">Transaction Type</div>
                                <div className="table-cell">Reference-Identifier</div>
                            </div>
                        </div>
                        <div className="table-body">
                            {filteredData?.slice((currentPage - 1) * 10, currentPage * 10)?.map((item, index) => (
                                <div className="table-row customer_line_item" key={index}>
                                    <div className="table-cell">
                                        <input
                                            type="radio"
                                            name="customer"
                                            value={`${item?.CUSTOMER}-${item?.EDITransactionType}`}
                                            checked={
                                                selectedCustomer?.customerName === item?.CUSTOMER &&
                                                selectedCustomer?.transactionType === item?.EDITransactionType
                                            }
                                            onChange={() =>
                                                handleCustomerSelection(item?.CUSTOMER, item?.EDITransactionType)
                                            }
                                        />
                                        {item?.CUSTOMER}
                                    </div>
                                    <div className="table-cell">{item?.EDITransactionType}</div>
                                    <div className="table-cell">
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <input
                                                type="text"
                                                placeholder="Reference-Identifier"
                                                value={referenceIdentifiers[`${item?.CUSTOMER}-${item?.EDITransactionType}`] || ''}
                                                data-transaction-type={item?.EDITransactionType}
                                                data-customer-name={item?.CUSTOMER}
                                                onChange={handleReferenceChange}
                                            />
                                            <button
                                                onClick={handleViewStatusClick}
                                                className="view-status-button"
                                                disabled={
                                                    !isViewStatusEnabled(item) && (selectedCustomer?.customerName !== item?.CUSTOMER || selectedCustomer?.transactionType !== item?.EDITransactionType)
                                                }
                                            >
                                                View Status
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="pagination">
                        <button onClick={prevPage} disabled={currentPage === 1}>
                            Back
                        </button>
                        {renderPageNumbers()}
                        <button onClick={nextPage} disabled={currentPage === totalPages}>
                            Next
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CustomerTransactionTab;
